(function () {
  if (window.__ibmRailBound) return;
  window.__ibmRailBound = true;

  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!form.classList || !form.classList.contains('ibm-rail-atc-form')) return;

    event.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    if (!button) return;

    var originalLabel = button.textContent.trim();
    button.disabled = true;
    button.textContent = '…';

    try {
      var addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      });
      if (!addResponse.ok) throw new Error('add-failed');

      button.classList.add('is-added');
      button.textContent = button.dataset.addedLabel || 'Added ✓';

      var cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('cart-failed');
      var cart = await cartResponse.json();

      document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble')
        .forEach(function (element) { element.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (error) {
      button.textContent = 'Try again';
    } finally {
      setTimeout(function () {
        button.disabled = false;
        button.classList.remove('is-added');
        button.textContent = originalLabel;
      }, 2000);
    }
  });
})();
